module.exports = __webpack_public_path__ + "static/media/remember_09.a466df96.png";